<div class="app-select-wrapper">
  <select [disabled]="isDisabled" (change)="onChange($event)" [ngClass]="[style, size, spacing, stateClass]">
    <option value="" [disabled]="isDefaultDisabled" [selected]="!selectedValue">-</option>
    @for (option of options; track option) {
      <option [value]="option.value" [selected]="option.value === selectedValue">
        {{ option.label }}
      </option>
    }
  </select>
</div>
